// extracted by mini-css-extract-plugin
module.exports = {"filledSVG":"FilledLeftArrow_filledSVG__gBL7r","filledSVGRotate":"FilledLeftArrow_filledSVGRotate__eje7Z"};